<template>
<div>
	<field
		class="mb-2"
		:params="{
			type: 'btn-group',
			tabStyling: true,
			buttons: tabButtons,
			disableNull: true
		}"
		v-model="selectedElement">
	</field>

	<table-list :record-name="recordLabelMap[selectedElement]"
		:fields="tableFields"
		:records="flattenedRecordsFromNested(selectedElement)"
		:hide-record-count="true"
		:sortable="true"
		:has-edit="false"
		:other-buttons="otherButtons"
		:records-selectable="selectedElement != 'additional-factors' && !isFinalized"
		:records-selected="selectedRecords"
		:id-field="recordIdField"
		v-on:selectedRecordsChange="setSelectedRecords"
		v-on:viewSources="openSourcesModal"
		v-on:edit="editRecord">

		<div class="d-flex justify-content-between align-items-center mb-2">

			<h3 class="mb-0">All {{ elementLabelMap[selectedElement] }}</h3>

			<div class="d-flex">
				<info-box v-if="selectedElement == 'labour'" class="mr-1"
					label="Total Labour Hours" 
					:value="totalLabourHours.toFixed(2)">
				</info-box>

				<info-box
					:label="'Total Value ' + elementLabelMap[selectedElement]" 
					:value="totalElementValue.toCurrency()">
				</info-box>
			</div>

		</div>

		<button v-if="selectedRecords.length > 0" class="btn btn-light" v-on:click="editBulkSelection">
			<i class="fa fa-pencil-alt"></i>
			Edit Selected
		</button>

	</table-list>

	<div class="d-flex justify-content-end mb-2">
		<info-box v-if="selectedElement == 'labour'" class="mr-1"
			label="Total Labour Hours" 
			:value="totalLabourHours.toFixed(2)">
		</info-box>

		<info-box
			:label="'Total Value ' + elementLabelMap[selectedElement]" 
			:value="totalElementValue.toCurrency()">
		</info-box>
	</div>

	<modal-dialog :modal-visible="sourcesModal.visible"
		:title="sourcesModal.title"
		modal-size="modal-lg"
		cancel-button-text="Done"
		:submit-visible="false"
		v-on:closeModal="sourcesModal.visible = false">

		<table-list :record-name="recordLabelMap[selectedElement]"
			:fields="[
				{label: 'Source Component',key:'sourceComponentName'},
				...tableFields
			]"
			:records="sourcesModal.records"
			:sortable="true"
			:has-edit="false"
			v-on:edit="editRecord">
		</table-list>

	</modal-dialog>

	<bid-element-bulk-edit-modal :visible="compiledEditModal.visible"
		:title="compiledEditModal.title"
		:records="selectedRecords"
		:type="recordTypeMap[selectedElement]"
		:records-are-compiled="true"
		:bid-id="bidId"
		v-on:closeModal="compiledEditModal.visible = false"
		v-on:saved="bulkEditSaved">
	</bid-element-bulk-edit-modal>
</div>
</template>
<script type="text/javascript">
	
import TableList from "@/components/TableList"
import InfoBox from "@/components/InfoBox"
import Field from "@/components/Field"
import BidElementBulkEditModal from "@/pages/project/project_tabs/bidding/components/BidElementBulkEditModal"
import FormGroup from "@/components/FormGroup"
import ModalDialog from "@/components/ModalDialog"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "CompiledBidElements",
	components: {
		TableList,
		InfoBox,
		Field,
		ModalDialog,
		FormGroup,
		BidElementBulkEditModal
	},
	mixins: [ProjectBidMixins],
	props: [
		"bidId",
		"isFinalized"
	],
	data() {
		return {
			selectedElement: 'materials',
			selectedRecords: [],
			sourcesModal: {
				visible: false,
				title: "",
				recordTitle: "",
				records: []
			},
			compiledEditModal: {
				visible: false,
				title: "",
			},
			elementLabelMap: {
				materials: 'Materials',
				labour: 'Labour',
				equipment: 'Equipment',
				'supplier-quotes' : 'Supplier Quotes',
				'additional-factors' : 'Additional Factors'
			},
			recordLabelMap: {
				materials: 'Material',
				labour: 'Labour Classification',
				equipment: 'Equipment Item',
				'supplier-quotes' : 'Supplier Quote',
				'additional-factors' : 'Additional Factor'
			}
		}
	},
	watch: {
		bidId() {
			if (this.bidId)
				this.fetchAllComponents(this.bidId)
			

			if (this.bidId && this.$store.projectBidObjects.length == 0) {
				this.fetchBidObjects(this.bidId)
			}
		}
	},
	computed: {
		tabButtons() {
			let buttons = [], vm = this
			Object.keys(this.elementLabelMap).forEach(value => {
				buttons.push({text: vm.elementLabelMap[value], value})
			})

			return buttons
		},
		otherButtons() {

			let buttons = []
			if (this.selectedElement == 'labour' || this.selectedElement == 'materials' || this.selectedElement == 'equipment') {
				buttons.push({
					text: 'Sources',
					icon: 'fa-chevron-right',
					click: 'viewSources',
					class: 'btn-light',
					//condition: ['isCompositeLineItem',true]
				})
			}

			if (this.selectedElement != 'additional-factors' && !this.isFinalized) {
				buttons.push({
					text: 'Edit',
					icon: 'fa-pencil-alt',
					click: 'edit',
					class: 'btn-light'
				}) 
			}

			return buttons
		},
		totalElementValue() {
			return this.flattenedRecordsFromNested(this.selectedElement).reduce((acc,item) => acc + +item.totalRaw,0)
		},
		totalLabourHours() {
			if (this.selectedElement == 'labour') 
				return this.flattenedRecordsFromNested(this.selectedElement).reduce((acc,cl) => +cl.hrs + acc,0)
			
			return 0
		},
		tableFields() {
			if (this.selectedElement == 'materials')
				return this.partsFields
			else if (this.selectedElement == 'labour') 
				return this.labourFields
			else if (this.selectedElement == 'equipment') 
				return this.equipmentFields
			else if (this.selectedElement == 'supplier-quotes') 
				return [{label: 'Source Component',key:'sourceComponentName'},
					...this.quotesFields
				]
			else if (this.selectedElement == 'additional-factors') 
				return [{label: 'Source Component',key:'sourceComponentName'},
					...this.additionalFactorFields
				]
			
		},
		recordIdField() {
			let map = {
				materials: "objectRecordId",
				labour: "objectRecordId",
				equipment: "equipment_type_id",
				'supplier-quotes': "objectRecordId",
				'additional-factors': "objectRecordId"
			}

			return map[this.selectedElement]
		}
	},
	methods: {
		filterBidRecordsToType(bidObjects) {
			return bidObjects
				.filter(obj => obj.type == this.recordTypeMap[this.selectedElement])
		},
		editRecord(record) {
			this.compiledEditModal.visible = true
			this.compiledEditModal.title = "Edit Global " + this.recordLabelMap[this.selectedElement]
			
			this.selectedRecords = [record]
		},
		editBulkSelection() {
			this.compiledEditModal.visible = true
			this.compiledEditModal.title = "Bulk Edit Global " + this.recordLabelMap[this.selectedElement]
		},
		setSelectedRecords(records) {
			this.selectedRecords = records
		},
		appendSourceComponentToSourceRecords(sourceRecords,resultRecords) {
			return sourceRecords.map(record => {
				let matchingResultRecord = resultRecords.find(resultRecord => resultRecord.id == record.objectRecordId)

				record.sourceComponentName = ""
				if ("JobBidComponent" in matchingResultRecord && matchingResultRecord.JobBidComponent)
					record.sourceComponentName = matchingResultRecord.JobBidComponent.item_number + ". " + matchingResultRecord.JobBidComponent.name

				return record
			})
		},
		openSourcesModal(record) {
			let vm = this
			this.sourcesModal.visible = true
			this.sourcesModal.title = "Sources"

			this.sourcesModal.records = record.sourceRecords

			this.fetchSourceObjects(record.sourceRecords.map(record => record.objectRecordId)).then(response => {
				if (response.success) {
					//merge the source components into the source records
					vm.sourcesModal.records = vm.appendSourceComponentToSourceRecords(vm.sourcesModal.records,response.data)
				}
			})
		},
		fetchSourceObjects(sourceObjectIds) {
			let vm = this

			let params = {
				include: [
					"JobBidComponent"
				],
				filters: [
					["id",sourceObjectIds]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("JobBidComponentObject/get",params).then(response => {
					resolve(response)
				})

			})
		},
		bulkEditSaved() {
			this.fetchAllComponents(this.bidId)
			this.fetchBidObjects(this.bidId)
		}
	},
	created() {
		if (this.bidId)
			this.fetchAllComponents(this.bidId)

		if (this.bidId && this.$store.projectBidObjects.length == 0) {
			this.fetchBidObjects(this.bidId)
		}

	}
}
</script>